import { serviceNames, diContainer } from '../../service-setup/diContainer';
import { ProductRepository } from '../repositories/ProductRepository';
import { Product } from '../domain/entities/Product';

export class PopulateProductFromServerState {
    private productRepository: ProductRepository;
    private product: Product;

    constructor(productState: Product) {
        this.productRepository = diContainer.get(serviceNames.productRepository);
        this.product = productState;
    }

    public execute = () => {
        this.productRepository.setProducts([Product.fromPlainObject(this.product)]);
    };
}
